import apiClient from './api';
import { DatevSettings } from '../types/einstellungen';

export const EinstellungenService = {
  getDatev: async (): Promise<DatevSettings> =>
    (await apiClient.get<DatevSettings>('/einstellungen/datev')).data,

  saveDatev: async (datevEmail: string | null, version: number): Promise<DatevSettings> =>
    (await apiClient.put<DatevSettings>('/einstellungen/datev', { datevEmail, version })).data,
};
